import React from "react";
import { PATHS } from "../../constant";
import { Link } from "react-router-dom";

const ServerError = () => {
  const error500 =
    "https://pmiic-local-files.s3.ap-south-1.amazonaws.com/500.png";
  return (
    <div className="no-page-wrapper">
      <img src={error500} alt="Page not found" className="error-img" />
      <p className="go-to-text">
        Go back to{" "}
        <Link to={PATHS.HOME} className="previous-page">
          Previous Page
        </Link>
      </p>
    </div>
  );
};

export default ServerError;
